<script>
export default {
  name: 'LoadingView',
  props: {
    load: { type: Function, required: false },
    loadingState: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      internalState:
        typeof this.$props.loadingState !== 'undefined'
          ? this.$props.loadingState
          : {
              pending: false,
              data: null,
              error: null
            }
    }
  },
  computed: {
    activeValue() {
      return typeof this.$props.loadingState !== 'undefined' ? this.$props.loadingState : this.internalState
    },
    isPending() {
      return this.activeValue.pending
    },
    hasError() {
      return !!this.activeValue.error
    },
    isDone() {
      return !this.isPending && !this.hasError
    }
  },
  async mounted() {
    await Promise.resolve(this._load())
  },
  methods: {
    async _load() {
      const loadingState = {
        data: this.activeValue.data,
        pending: true,
        error: null
      }
      this.updateState(loadingState)
      try {
        loadingState.data = await Promise.resolve(this.$props.load())
      } catch (error) {
        loadingState.error = error
      } finally {
        loadingState.pending = false
        this.updateState(loadingState)
      }
    },
    async reLoad() {
      await this._load()
    },
    updateState(value) {
      this.$emit('update:loadingState', value)
      this.internalState = value
    }
  },
  watch: {
    loadingState: async function(oldValue, newValue) {
      if (!newValue) {
        return
      }
      if (
        newValue.pending === this.internalState.pending &&
        newValue.data === this.internalState.data &&
        newValue.error === this.internalState.error
      ) {
        return
      }
      this.internalState = newValue
      if (newValue.pending === true) {
        await this._load()
      }
    }
  }
}
</script>

<template>
  <div v-if="isPending">
    <slot name="pending">
      <v-alert color="grey" :outlined="true" title="Loading...">
        <p>Loading...</p>
      </v-alert>
    </slot>
  </div>
  <div v-else-if="hasError">
    <slot name="error">
      <v-alert color="red" :outlined="true" title="An error occurred while loading the data.">
        <p><strong>An error occurred while loading the data.</strong></p>
        <p>{{ loadingState.error.message }}</p>
      </v-alert>
    </slot>
  </div>
  <div v-else-if="isDone">
    <slot name="done" />
  </div>
  <div v-else></div>
</template>

<style lang="scss"></style>
